// Google reviews for Specpixel Entertainment PTY LTD.
// Pasted by the owner from the studio's Google Business listing.
export const GOOGLE_REVIEWS_URL = "https://share.google/dqRsCGHONkKS1yIQo";

export const TESTIMONIALS = [
  {
    name: "Adrian Motz",
    stars: 5,
    date: "2 years ago",
    text: "Specpixel Entertainment is an wonderfully skilled team of artist, that were able to deliver what I wanted in a timely manner and of a very high quality. Even going above and beyond to do extra work for a provided 3D asset. For an affordable price on UE5 assets featuring Substrate the required texture was high quality, and good looking.",
  },
  {
    name: "xNicktendox",
    stars: 5,
    date: "a year ago",
    text: "I hired this company to perform localization for my teams latest game and the results turned out exactly as expected and earlier than the deadline. They even offered help after the job was done. Highly recommend.",
  },
  {
    name: "Watched",
    stars: 5,
    date: "3 years ago",
    text: "Amazing people! I posted a job I needed done inside of a community discord, and within a day Specpixel contacted me in direct messages. They helped me for free and told me it's too simple to charge. Very kind and knowledged people — when I get on more advanced stuff I will definitely purchase with these people.",
  },
  {
    name: "Matthew McGinnis",
    stars: 5,
    date: "3 years ago",
    text: "Specpixel reached out to me eager to help me with the specialized Niagara particle system I had planned for my project. I am beyond excited and satisfied with the final product. A dedicated staff that goes the extra mile in helping you integrate the final product into your project. Highly recommended.",
  },
];
